<section class="admin-home">

  <div class="section-header">
    <div>
      <span class="eyebrow">Home Page</span>

      <h2>Hero Content</h2>

      <p>
        Manage the text and background displayed at the top of the home page.
      </p>
    </div>
  </div>

  @if (isLoading) {
    <div class="state-card">
      Loading Home page...
    </div>
  }
  @else {

    <div class="editor-card">

      <!-- =====================================================
           TEXT
           ===================================================== -->

      <div class="editor-section">

        <div class="editor-section-heading">
          <h3>Hero Text</h3>

          <p>
            Update the primary messaging displayed over the hero background.
          </p>
        </div>

        <div class="field">
          <label for="homeEyebrow">
            Eyebrow Text
          </label>

          <input
            id="homeEyebrow"
            type="text"
            [(ngModel)]="eyebrowText"
            maxlength="150"
          />
        </div>

        <div class="field">
          <label for="homeTitle">
            Hero Title
          </label>

          <input
            id="homeTitle"
            type="text"
            [(ngModel)]="title"
            maxlength="150"
          />
        </div>

        <div class="field">
          <label for="homeSubtitle">
            Subtitle
          </label>

          <textarea
            id="homeSubtitle"
            [(ngModel)]="subtitle"
            rows="4"
            maxlength="500"
          ></textarea>
        </div>

      </div>


      <!-- =====================================================
           BACKGROUND TYPE
           ===================================================== -->

      <div class="editor-section">

        <div class="editor-section-heading">
          <h3>Hero Background</h3>

          <p>
            Choose whether the Home page uses a video or image background. 
            <br>Note: To get the default video and fallback image back swap to image then back to video again and save
          </p>
        </div>

        <div class="background-options">

          <label
            class="background-option"
            [class.selected]="backgroundType === 'Video'"
          >
            <input
                type="radio"
                name="backgroundType"
                value="Video"
                [ngModel]="backgroundType"
                (ngModelChange)="backgroundTypeChanged($event)"
                />

            <span>
              <strong>Video</strong>
              <small>MP4 up to 25 MB</small>
            </span>
          </label>

          <label
            class="background-option"
            [class.selected]="backgroundType === 'Image'"
          >
            <input
                type="radio"
                name="backgroundType"
                value="Image"
                [ngModel]="backgroundType"
                (ngModelChange)="backgroundTypeChanged($event)"
                />

            <span>
              <strong>Image</strong>
              <small>JPEG, PNG, or WebP up to 5 MB</small>
            </span>
          </label>

        </div>


        <!-- ===================================================
             CURRENT BACKGROUND
             =================================================== -->

        <div class="media-editor">

          <div class="media-label">
            Current Background
          </div>

          @if (backgroundUrl) {

            <div class="media-preview">

              @if (backgroundType === 'Video') {
                <video
                  [src]="backgroundUrl"
                  [muted]="true"
                  loop
                  autoplay
                  playsinline
                  controls
                ></video>
              }
              @else {
                <img
                  [src]="backgroundUrl"
                  alt="Current Home hero background"
                />
              }

            </div>

          }
          @else {
            <div class="empty-media">
              No background selected. The hero will use a black background.
            </div>
          }

          <div class="media-actions">

            <label class="upload-button">
              Replace Background

              <input
                type="file"
                [accept]="backgroundType === 'Video'
                  ? 'video/mp4'
                  : 'image/jpeg,image/png,image/webp'"
                (change)="backgroundSelected($event)"
              />
            </label>

            @if (backgroundUrl) {
              <button
                type="button"
                class="secondary-button danger"
                (click)="removeBackground()"
              >
                Remove
              </button>
            }

          </div>

        </div>

      </div>


      <!-- =====================================================
           VIDEO FALLBACK
           ===================================================== -->

      @if (backgroundType === 'Video') {
        <div class="editor-section">

          <div class="editor-section-heading">
            <h3>Video Fallback Image</h3>

            <p>
              Displayed while the video loads or when video playback is unavailable.
            </p>
          </div>

          <div class="media-editor">

            @if (fallbackUrl) {
              <div class="media-preview fallback-preview">
                <img
                  [src]="fallbackUrl"
                  alt="Home hero fallback"
                />
              </div>
            }
            @else {
              <div class="empty-media">
                No fallback image selected.
              </div>
            }

            <div class="media-actions">

              <label class="upload-button">
                Replace Fallback

                <input
                  type="file"
                  accept="image/jpeg,image/png,image/webp"
                  (change)="fallbackSelected($event)"
                />
              </label>

              @if (fallbackUrl) {
                <button
                  type="button"
                  class="secondary-button danger"
                  (click)="removeFallback()"
                >
                  Remove
                </button>
              }

            </div>

          </div>

        </div>
      }


      <!-- =====================================================
           SAVE
           ===================================================== -->

      <div class="editor-footer">

        <button
          type="button"
          class="save-button"
          [disabled]="isSaving"
          (click)="saveHero()"
        >
          @if (isSaving) {
            Saving...
          }
          @else {
            Save Home Page
          }
        </button>

      </div>

    </div>
  }

</section>